import React, { useEffect, useState } from "react";
import { Form, Button, Typography, Flex, Grid, Radio, Tooltip, Select, Upload, DatePicker, Switch } from "antd";
import { App } from "antd";
import { InboxOutlined, InfoCircleOutlined } from "@ant-design/icons";
import InputField from "../../../../../components/Input/Input";
import { useForm } from "antd/es/form/Form";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { fetchSuppliersCode, createSupplier } from "../suppliersThunk";
import { fetchLocations, fetchSuppliers } from "../../../../../store/commonThunks/lookups";
import Dropdown from "../../../../../components/DropDown/DropDown";
import { createSupplierPayload } from "../../../../../utils/suppliers";
import { setIsEditSupplier, setSelectedSupplier } from "../suppliersSlice";
import "./supplier.css";
import { getCountryList, getISOFromCountryName, gstTypeOptions, indianStates } from "../../../../../lib/currency";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { getAccessType } from "../../../../../lib/functions";
import { useWatch } from "antd/es/form/Form";
import dayjs from "dayjs";
const { Option } = Select;

const { Title } = Typography;
const { useBreakpoint } = Grid;

const CreateSupplierForm = ({ isDrawer = false, onSuccess, form: externalForm, }) => {
  const { modal } = App.useApp();
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const location = useLocation();
  const navigate = useNavigate();
  const [internalForm] = useForm();
  const form = externalForm || internalForm;

  const isStacked = isDrawer || !screens.lg;
  const authInfo = useSelector((state) => state.auth.auth_info);

  const isIndia =
    authInfo?.country?.toLowerCase() === "india";

  const gstEnabled =
    authInfo?.gst_enabled === "yes";
  const isIndiaGst = isIndia && gstEnabled;


  const isPharmacy = ["PharmaERP_Pro", "PharmaERP_Basic", "PharmaBooks_pro", "PharmaERP_Standard", "PharmaBooks_Standard"].includes(authInfo?.subscription);


  const { isEditSupplier, selectedSupplier, supplierCode } = useSelector(
    (state) => state.suppliers
  );
  const selectedCountry = useWatch("country", form);

  const isAlsoDebitor = useWatch("is_also_debitor", form);
  const selectedGstType = useWatch("gst_type", form);
  const isIndianSupplier =
    selectedCountry?.toLowerCase() === "india";
  const isGstRequired =
    isIndia &&
    (selectedGstType === "regular" ||
      selectedGstType === "composition");
  const countries = getCountryList();

  const { locations } = useSelector((state) => state.lookups);
  const { user } = useSelector((state) => state.auth);
  const [salesmanCountryCode, salesmanCountryCodeSet] = useState();
  const [salesmanContactNo, salesmanContactNoSet] = useState("");
  const [officeCountryCode, officeCountryCodeSet] = useState();
  const [officeContactNo, officeContactNoSet] = useState("");
  const [countryCode, countryCodeSet] = useState();
  const [contactNo, contactNoSet] = useState("");
  const [fileList, setFileList] = useState([]);
  const [access_type, access_type_set] = useState("");

  useEffect(() => {
    const access = getAccessType("supplier_entry");
    access_type_set(access);
  }, []);

  useEffect(() => {
    if (
      (selectedGstType === "regular" ||
        selectedGstType === "composition")
    ) {
      form.setFieldsValue({ country: "India" });
    }
  }, [selectedGstType]);

  const handleCancel = () => {
    dispatch(setIsEditSupplier(false));
    dispatch(setSelectedSupplier(null));
    navigate(-1);
  };
  useEffect(() => {
    if (supplierCode) {
      form.setFieldsValue({ acc_code: supplierCode });
    }
  }, [supplierCode, form]);

  const handleSave = async (values) => {

    const gmailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!values.acc_code) {
      modal.warning({
        title: "Account Code Missing.",
      });
      return true;
    }
    // Fixed: Check string length properly
    if (values?.acc_name?.length > 255) {
      modal.warning({
        title: "Account Name max Length Exceeded.",
      });
      return true;
    }
    // Fixed: Check if address exists before checking length
    if (values.address && values.address?.length > 255) {
      modal.warning({
        title: "Address max Length Exceeded.",
      });
      return true;
    }
    // Fixed: Better number validation
    if (values.opening_balance && isNaN(Number(values.opening_balance))) {
      modal.warning({
        title: "Opening Balance must be a valid number.",
      });
      return true;
    }
    if (values.email_address && !gmailRegex.test(values.email_address)) {
      modal.warning({
        title: "Provide Valid Email-ID.",
      });
      return true;
    }
    // Fixed: Check if institution_name exists before checking length
    if (values.institution_name && values.institution_name?.length > 255) {
      modal.warning({
        title: "Institution Name max Length Exceeded.",
      });
      return true;
    }
    // Fixed: Check if vat_no exists before checking length
    if (values.vat_no && values.vat_no?.length > 255) {
      modal.warning({
        title: `VAT No exceeded limit`,
      });
      return true;
    }
    // Add validation for credit_count if needed
    if (values.credit_count && !Number.isInteger(Number(values.credit_count))) {
      modal.warning({
        title: "Credit Count must be a whole number.",
      });
      return true;
    }
    if (isEditSupplier) {
      values.action = "update";
    }

    if (values.licence_validity) {
      values.licence_validity = dayjs(values.licence_validity).format("YYYY-MM-DD");
    }


    const payload = createSupplierPayload(values, user, isEditSupplier ? selectedSupplier?.acc_id : null);


    if (isEditSupplier) {
      payload.action = "update";
      payload.acc_id = selectedSupplier.acc_id;
    }

    payload.document_url = fileList;
    payload.existing_document = fileList
      .filter((file) => file.url)
      .map((file) => file.url)
      .join(",");


    try {
      const res = await dispatch(createSupplier(payload)).unwrap();
      if (res && !res.error) {
        modal.success({
          title: res?.msg || "Supplier saved successfully",
        });
        // 🔥 We already know acc_code before save
        const newCode = values.acc_code;

        // refresh customer list
        const list = await dispatch(fetchSuppliers()).unwrap();

        // find the new customer
        const created = list?.find((c) => c.acc_code === newCode);

        // build params to send back
        const params = created
          ? { state: { newSupplierId: created.acc_id } }
          : undefined;

        if (isDrawer) {
          onSuccess?.(created);
        } else {
          // 🔥 Return to purchase if returnTo exists
          navigate(location?.state?.from || "/purchase");
        }
      }
    } catch (error) {
      modal.warning({
        title: error.message || "Failed to save supplier",
      });
    }
  };

  const handlePhoneChange = (value, countryData) => {
    const newCountryCode = countryData?.dialCode || countryCode;

    // Only digits in input (no country code)
    const onlyNumber = value.replace(/\D/g, "");

    countryCodeSet(newCountryCode);
    contactNoSet(onlyNumber);
    form.setFieldsValue({
      country_code: newCountryCode,
      contact_no: onlyNumber,
    });
  };

  const handleSalesmanPhoneChange = (value, countryData) => {
    const newCountryCode = countryData?.dialCode || salesmanCountryCode;

    // Only digits in input (no country code)
    const onlyNumber = value.replace(/\D/g, "");

    salesmanCountryCodeSet(newCountryCode);
    salesmanContactNoSet(onlyNumber);
    form.setFieldsValue({
      salesman_country_code: newCountryCode,
      salesman_contact_no: onlyNumber,
    });
  };

  const handleOfficePhoneChange = (value, countryData) => {
    const newCountryCode = countryData?.dialCode || salesmanCountryCode;

    // Only digits in input (no country code)
    const onlyNumber = value.replace(/\D/g, "");

    officeCountryCodeSet(newCountryCode);
    officeContactNoSet(onlyNumber);
    form.setFieldsValue({
      office_country_code: newCountryCode,
      office_contact_no: onlyNumber,
    });
  };

  const defaultCountry = getISOFromCountryName(authInfo?.country);

  useEffect(() => {
    if (isEditSupplier && selectedSupplier) {
      const supplier = { ...selectedSupplier };

      // 🟢 Reverse map credit_day / credit_month into credit_time + credit_count
      if (supplier.credit_month && Number(supplier.credit_month) > 0) {
        supplier.credit_time = "months";
        supplier.credit_count = supplier.credit_month;
      } else if (supplier.credit_day && Number(supplier.credit_day) > 0) {
        supplier.credit_time = "days";
        supplier.credit_count = supplier.credit_day;
      } else {
        supplier.credit_time = "";
        supplier.credit_count = null;
      }

      if (supplier.licence_validity) {
        supplier.licence_validity = dayjs(supplier.licence_validity);
      }

      supplier.state = supplier.province || "";

      form.setFieldsValue(supplier);

      // Load existing documents into Upload component
      if (supplier.document_url) {
        const files = supplier.document_url.split(",").map((url, index) => ({
          uid: `existing-${index}`,
          name: url.split("/").pop(),
          status: "done",
          url: url,
        }));

        setFileList(files);
      } else {
        setFileList([]);
      }

    }
  }, [isEditSupplier, selectedSupplier, form]);

  useEffect(() => {
    dispatch(fetchSuppliersCode());
    dispatch(fetchLocations());
  }, [dispatch]);

  useEffect(() => {
    return () => {
      // cleanup on unmount
      dispatch(setIsEditSupplier(false));
      dispatch(setSelectedSupplier(null));
    };
  }, [dispatch]);


  return (
    <div className="invoice-form">
      {!isDrawer && <Title
        level={2}
        style={{
          marginBottom: "32px",
        }}
      >
        {isEditSupplier ? "Update Supplier" : "Create New Supplier"}
      </Title>}
      <Form
        form={form}
        layout={isDrawer ? "vertical" : "horizontal"}
        onFinish={handleSave}
        initialValues={{
          acc_code: supplierCode,
          opening_balance: 0,
          credit_limit: 0,
          budget: 0,
        }}
        variant="filled"
        style={{ maxWidth: isDrawer ? "100%" : "1400px" }}
        className={`responsive-form ${isDrawer ? "drawer-form" : ""}`}
        colon={false}
        labelCol={{
          xs: { span: 24 },
          sm: { span: 8 },
          md: { span: 8 },
          lg: { span: 6 },
          xl: { span: 6 },
          xxl: { span: 6 },
        }}
        wrapperCol={{
          xs: { span: 24 },
          sm: { span: 16 },
          md: { span: 16 },
          lg: { span: 18 },
          xl: { span: 15 },
          xxl: { span: 16 },
        }}
      >
        {/* Buttons */}
        <Form.Item
          style={{
            marginTop: "24px",
          }}
        >
          <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
            {!isDrawer && (
              <Button
                size="large"
                shape="default"
                onClick={handleCancel}
                className="traic-button"
              >
                Back
              </Button>
            )}
            {!isDrawer && access_type == "WRITE" && (
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="traic-button"
              >
                {isEditSupplier ? "Update" : "Save"}
              </Button>
            )}
          </Flex>
        </Form.Item>

        <Flex
          gap={!screens.md || !screens.xl ? 10 : 80}
          justify="center"
          style={{
            flexDirection: isStacked ? "column" : "row",
            width: "100%",
            marginBottom: "24px",
          }}
        >
          {/* Left column */}
          <Flex
            vertical
            gap={10}
            style={{
              width: isStacked ? "100%" : "40%",
            }}
          >
            <Form.Item
              label="Code"
              name="acc_code"
              className="supplier-form"
              rules={[{ required: true, message: "Code is required" }]}
            >
              <InputField disabled />
            </Form.Item>
            <Form.Item
              label="Supplier Name"
              name="acc_name"
              className="supplier-form"
              rules={[{ required: true, message: "Supplier name is required" }]}
            >
              <InputField
                placeholder="Supplier name"
                data-testid="supplier-name-input"
              />
            </Form.Item>
            <Form.Item
              label="Institution Name"
              name="institution_name"
              className="supplier-form"
            >
              <InputField
                placeholder="Institution name"
                data-testid="institution-name-input"
              />
            </Form.Item>
            <Form.Item label="Address" name="address" className="supplier-form">
              <InputField placeholder="Address" data-testid="address-input" />
            </Form.Item>
            <Form.Item
              label="Email Address"
              name="email_address"
              className="supplier-form"
              rules={[{ required: true, message: "Email is required" }]}

            >
              <InputField placeholder="Email" data-testid="email-input" />
            </Form.Item>
            {/* Credit Time (Months / Days) */}

            <Form.Item
              label="Credit Time"
              name="credit_time"
              className="supplier-form"
            >
              <Radio.Group data-testid="credit-time-radio">
                <Radio value="months">Months</Radio>
                <Radio value="days">Days</Radio>
              </Radio.Group>
            </Form.Item>
            {/* {authInfo?.branch_company_type === "Pharmacy" && ( */}
            <Form.Item
              label="Credit Count"
              name="credit_count"
              className="supplier-form"
            >
              <InputField
                type="number"
                placeholder="Enter Days/Month"
                data-testid="credit-count-input"
                min={0}
                precision={0}
                step={1}
                onKeyPress={(e) => {
                  if (e.key === "." || e.key === ",") {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>
            {/* )} */}
            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Opening Due"
                name="opening_balance"
                className="supplier-form"
              >
                <InputField
                  type="text"
                  data-testid="opening-balance-input"
                  min={0}
                  onKeyPress={(e) => {
                    // Allow numbers, decimal point, and control keys
                    if (
                      !/[0-9.]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Delete"
                    ) {
                      e.preventDefault();
                    }
                    // Prevent multiple decimal points
                    if (e.key === "." && e.target.value.includes(".")) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Limit to 2 decimal places
                    if (value && value.includes(".")) {
                      const [whole, decimal] = value.split(".");
                      if (decimal && decimal.length > 2) {
                        const formattedValue = `${whole}.${decimal.slice(
                          0,
                          2
                        )}`;
                        // Update the form value
                        form.setFieldValue("opening_balance", formattedValue);
                      }
                    }
                  }}
                />
              </Form.Item>
            )}
            <Form.Item name="country_code" hidden>
              <input type="hidden" />
            </Form.Item>
            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Contact No"
                name="contact_no"
                className="supplier-form"
                rules={[
                  { required: false },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const phoneNumber = parsePhoneNumberFromString(
                        `+${value}`
                      );

                      if (!phoneNumber || !phoneNumber.isValid()) {
                        return Promise.reject("Invalid phone number");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                {/* <PhoneInput
                country={defaultCountry}
                inputStyle={{
                  width: "100%",
                  height: "39.6px",
                  background: "rgba(0,0,0,0.04)",
                  borderColor: "transparent",
                }}
                placeholder="Contact no"
                inputProps={{
                  "data-testid": "phone-input",
                }}
              /> */}

                <PhoneInput
                  country={defaultCountry}
                  value={`+${countryCode} ${contactNo}`} // ONLY phone number, not country code
                  onChange={(value, countryData) =>
                    handlePhoneChange(value, countryData)
                  }
                  inputStyle={{
                    width: "100%",
                    height: "35.2px",
                    background: "rgba(0,0,0,0.04)",
                    borderColor: "transparent",
                  }}
                  placeholder="Contact no"
                  inputProps={{ "data-testid": "pharma-phone-input" }}
                  enableSearch={true}
                  disableCountryGuess={true}
                  disableCountryCode={false} // <-- IMPORTANT
                  disableDropdown={false}
                />
              </Form.Item>
            )}
          </Flex>

          {/* Right column */}
          <Flex
            vertical
            gap={10}
            style={{
              width: isStacked ? "100%" : "40%",
            }}
          >
            {authInfo?.branch_company_type !== "Pharmacy" && (
              <Form.Item
                label="Opening Due"
                name="opening_balance"
                className="supplier-form"
              >
                <InputField
                  type="text"
                  data-testid="opening-balance-input"
                  min={0}
                  onKeyPress={(e) => {
                    // Allow numbers, decimal point, and control keys
                    if (
                      !/[0-9.]/.test(e.key) &&
                      e.key !== "Backspace" &&
                      e.key !== "Delete"
                    ) {
                      e.preventDefault();
                    }
                    // Prevent multiple decimal points
                    if (e.key === "." && e.target.value.includes(".")) {
                      e.preventDefault();
                    }
                  }}
                  onChange={(e) => {
                    const value = e.target.value;
                    // Limit to 2 decimal places
                    if (value && value.includes(".")) {
                      const [whole, decimal] = value.split(".");
                      if (decimal && decimal.length > 2) {
                        const formattedValue = `${whole}.${decimal.slice(
                          0,
                          2
                        )}`;
                        // Update the form value
                        form.setFieldValue("opening_balance", formattedValue);
                      }
                    }
                  }}
                />
              </Form.Item>
            )}
            {authInfo?.branch_company_type !== "Pharmacy" && (
              <Form.Item
                label="Contact No"
                name="contact_no"
                className="supplier-form"
                rules={[
                  { required: false },
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const phoneNumber = parsePhoneNumberFromString(
                        `+${value}`
                      );

                      if (!phoneNumber || !phoneNumber.isValid()) {
                        return Promise.reject("Invalid phone number");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <PhoneInput
                  country={defaultCountry}
                  value={`+${countryCode} ${contactNo}`} // ONLY phone number, not country code
                  onChange={(value, countryData) =>
                    handlePhoneChange(value, countryData)
                  }
                  inputStyle={{
                    width: "100%",
                    height: "35.2px",
                    background: "rgba(0,0,0,0.04)",
                    borderColor: "transparent",
                  }}
                  placeholder="Contact no"
                  inputProps={{ "data-testid": "phone-input" }}
                  enableSearch={true}
                  disableCountryGuess={true}
                  disableCountryCode={false} // <-- IMPORTANT
                  disableDropdown={false}
                />
              </Form.Item>
            )}

            <Form.Item
              label="Account Manager Name"
              name="acc_mgr"
              className="supplier-form"
            >
              <InputField placeholder="Account manager name" />
            </Form.Item>

            <Form.Item
              label={
                <span>
                  Institution Owner Name{" "}
                  <Tooltip title="Type multiple owner names separated by commas">
                    <InfoCircleOutlined />
                  </Tooltip>
                </span>
              }
              name="institution_owner"
              className="supplier-form"
            >
              <Select
                mode="tags"
                tokenSeparators={[","]}
                open={false}
                placeholder="Enter owner names"
              />
            </Form.Item>

            <Form.Item
              label="Country"
              name="country"
              className="supplier-form"
            >
              <Dropdown options={countries} placeholder="Select country" />
            </Form.Item>

            {isIndiaGst && isIndianSupplier && (
              <Form.Item
                name="state"
                label="State"
                className="supplier-form"
                rules={[{ required: true, message: "State is required" }]}
              >
                <Select placeholder="Select State" showSearch>
                  {indianStates.map((state) => (
                    <Option key={state.code} value={state.name}>
                      {state.name}
                    </Option>
                  ))}
                </Select>
              </Form.Item>)}

            <Form.Item
              label="Location/Area"
              name="location_id"
              className="supplier-form"
            >
              <Dropdown
                placeholder="Select location"
                options={(locations || []).map((el) => ({
                  label: el.location_name,
                  value: el.location_id,
                }))}
                data-testid="location-dropdown"
              />
            </Form.Item>

            <Form.Item
              label="PO Box"
              name="po_box"
              className="supplier-form"
            >
              <InputField placeholder="PO Box" />
            </Form.Item>

            <Form.Item
              label="Credit Limit"
              name="credit_limit"
              className="supplier-form"
            >
              <InputField
                type="text"
                placeholder="Credit limit"
                data-testid="credit-limit-input"
                min={0}
                precision={0}
                onKeyPress={(e) => {
                  // Allow numbers, decimal point, and control keys
                  if (
                    !/[0-9.]/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Delete"
                  ) {
                    e.preventDefault();
                  }
                  // Prevent multiple decimal points
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  // Limit to 2 decimal places
                  if (value && value.includes(".")) {
                    const [whole, decimal] = value.split(".");
                    if (decimal && decimal.length > 2) {
                      const formattedValue = `${whole}.${decimal.slice(0, 2)}`;
                      // Update the form value
                      form.setFieldValue("credit_limit", formattedValue);
                    }
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="Budget"
              name="budget"
              className="supplier-form"
              tooltip="Optional monthly spending cap for this vendor, used by workflow conditions — not enforced automatically"
            >
              <InputField
                type="text"
                placeholder="Budget"
                data-testid="budget-input"
                min={0}
                precision={0}
                onKeyPress={(e) => {
                  // Allow numbers, decimal point, and control keys
                  if (
                    !/[0-9.]/.test(e.key) &&
                    e.key !== "Backspace" &&
                    e.key !== "Delete"
                  ) {
                    e.preventDefault();
                  }
                  // Prevent multiple decimal points
                  if (e.key === "." && e.target.value.includes(".")) {
                    e.preventDefault();
                  }
                }}
                onChange={(e) => {
                  const value = e.target.value;
                  // Limit to 2 decimal places
                  if (value && value.includes(".")) {
                    const [whole, decimal] = value.split(".");
                    if (decimal && decimal.length > 2) {
                      const formattedValue = `${whole}.${decimal.slice(0, 2)}`;
                      // Update the form value
                      form.setFieldValue("budget", formattedValue);
                    }
                  }
                }}
              />
            </Form.Item>

            {isIndiaGst && (
              <Form.Item
                label="GST Type"
                name="gst_type"
                rules={[
                  { required: true, message: "GST Type is required" }
                ]}
                className="supplier-form"
                data-testid="gst-type-select-supp"
              >
                <Dropdown
                  options={gstTypeOptions}
                  placeholder="Select GST Type"
                  allowClear
                />
              </Form.Item>
            )}

            {/* VAT No. */}
            {(!isIndia || gstEnabled) && (
              <Form.Item
                label={isIndia ? "GST No." : "VAT No."}
                name="vat_no"
                rules={
                  isGstRequired
                    ? [
                      { required: true, message: "GST Number is required" },
                      {
                        pattern:
                          /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                        message: "Enter valid GSTIN",
                      },
                    ]
                    : []
                }
                extra={isIndia ? "Format: 22AAAAA0000A1Z5" : undefined}
                className="supplier-form">
                <InputField placeholder={isIndia ? "Enter GST Number" : "Enter VAT Number"} data-testid="vat-no-input" />
              </Form.Item>
            )}

            {/* <Form.Item label="GLN No." name="gln_no" className="supplier-form">
              <InputField placeholder="GLN No." data-testid="gln-no-input" />
            </Form.Item> */}

            {!isIndia && isPharmacy && (
              <Form.Item label="GLN No." name="gln_no" className="supplier-form">
                <InputField placeholder="GLN No." data-testid="gln-no-input" />
              </Form.Item>
            )}

            <Form.Item
              label="Company Prefix Length"
              name="company_prefix_length"
              className="supplier-form"
              rules={[
                {
                  type: "number",
                  min: 6,
                  max: 12,
                  transform: (value) =>
                    value === "" || value === null || value === undefined
                      ? undefined
                      : Number(value),
                  message: "Enter a valid Company Prefix Length",
                },
              ]}
            >
              <InputField
                type="number"
                min={1}
                max={12}
                step={1}
                placeholder="Enter Company Prefix Length"
                data-testid="company-prefix-length-input"
                onKeyPress={(e) => {
                  if (e.key === "." || e.key === "," || e.key === "-" || e.key === "+") {
                    e.preventDefault();
                  }
                }}
              />
            </Form.Item>

            <Form.Item
              label="Licence No"
              name="licence_no"
              className="supplier-form"
            >
              <InputField placeholder="Licence number" />
            </Form.Item>

            <Form.Item
              label="Licence Validity"
              name="licence_validity"
              className="supplier-form"
            >
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
              />
            </Form.Item>


            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Contact Person Name"
                name="contact_person_name"
                className="supplier-form"
              >
                <InputField
                  placeholder="Contact Person name"
                  data-testid="contact-person-name-input"
                />
              </Form.Item>
            )}
            <Form.Item name="office_country_code" hidden>
              <input type="hidden" />
            </Form.Item>

            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Office Contact No"
                name="office_contact_no"
                className="supplier-form"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const phoneNumber = parsePhoneNumberFromString(
                        `+${value}`
                      );

                      if (!phoneNumber || !phoneNumber.isValid()) {
                        return Promise.reject("Invalid phone number");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <PhoneInput
                  country={defaultCountry}
                  value={`+${officeCountryCode} ${officeContactNo}`} // ONLY phone number, not country code
                  onChange={(value, countryData) =>
                    handleOfficePhoneChange(value, countryData)
                  }
                  inputStyle={{
                    width: "100%",
                    height: "35.2px",
                    background: "rgba(0,0,0,0.04)",
                    borderColor: "transparent",
                  }}
                  placeholder="Office Contact no"
                  inputProps={{ "data-testid": "phone-input" }}
                  enableSearch={true}
                  disableCountryGuess={true}
                  disableCountryCode={false} // <-- IMPORTANT
                  disableDropdown={false}
                />
              </Form.Item>
            )}
            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Salesman Name"
                name="salesman_name"
                className="supplier-form"
              >
                <InputField
                  placeholder="Salesman name"
                  data-testid="salesman-name-input"
                />
              </Form.Item>
            )}
            <Form.Item name="salesman_country_code" hidden>
              <input type="hidden" />
            </Form.Item>
            {authInfo?.branch_company_type === "Pharmacy" && (
              <Form.Item
                label="Salesman Contact No"
                name="salesman_contact_no"
                className="supplier-form"
                rules={[
                  {
                    validator: (_, value) => {
                      if (!value) return Promise.resolve();

                      const phoneNumber = parsePhoneNumberFromString(
                        `+${value}`
                      );

                      if (!phoneNumber || !phoneNumber.isValid()) {
                        return Promise.reject("Invalid phone number");
                      }

                      return Promise.resolve();
                    },
                  },
                ]}
              >
                <PhoneInput
                  country={defaultCountry}
                  value={salesmanContactNo} // ONLY phone number, not country code
                  onChange={(value, countryData) =>
                    handleSalesmanPhoneChange(value, countryData)
                  }
                  inputStyle={{
                    width: "100%",
                    height: "35.2px",
                    background: "rgba(0,0,0,0.04)",
                    borderColor: "transparent",
                  }}
                  placeholder="Salesman Contact no"
                  inputProps={{ "data-testid": "phone-input" }}
                  enableSearch={true}
                  disableCountryGuess={true}
                  disableCountryCode={false} // <-- IMPORTANT
                  disableDropdown={false}
                />
              </Form.Item>
            )}

            <Form.Item
              label="Upload Documents"
              className="supplier-form"
            >
              <Upload
                multiple
                fileList={fileList}
                beforeUpload={() => false}
                onChange={({ fileList }) => {
                  if (fileList.length <= 5) {
                    setFileList(fileList);
                  }
                }}
                onRemove={(file) => {
                  setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
                }}
              >
                {fileList.length < 5 && (
                  <Button icon={<InboxOutlined />}>Upload (Max 5 files)</Button>
                )}
              </Upload>
            </Form.Item>
            {/* Replace existing Switch Form.Item with this */}
            <Form.Item
              name="is_also_debitor"
              valuePropName="checked"
              className="supplier-form"
              label="Also a Customer"
            >
              <Switch checkedChildren="Yes" unCheckedChildren="No" />
            </Form.Item>

            {/* ✅ Show customer opening balance only when: */}
            {/* switch is ON + no linked account exists yet */}
            {isAlsoDebitor && !selectedSupplier?.linked_acc_id && (
              <Form.Item
                name="customer_opening_balance"
                label="Opening Due (as Customer)"
                className="supplier-form"
                tooltip="Amount this party owed you as a customer before starting to use this software"
              >
                <InputField placeholder="0" type="number" />
              </Form.Item>
            )}
          </Flex>
        </Flex>

        {/* Bottom buttons */}
        <Form.Item
          style={{
            marginTop: "24px",
          }}
        >
          <Flex style={{ marginBottom: "32px", width: "25%" }} gap={32}>
            <Button
              size="large"
              shape="default"
              onClick={handleCancel}
              className="traic-button"
            >
              Back
            </Button>
            {!isDrawer && access_type == "WRITE" && (
              <Button
                type="primary"
                size="large"
                htmlType="submit"
                className="traic-button"
                data-testid="save-supplier-btn"
              >
                {isEditSupplier ? "Update" : "Save"}
              </Button>
            )}
          </Flex>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateSupplierForm;
